import React from "react";
import {TextContainer, Heading,List} from "@shopify/polaris";

const ExampleMessageTemplates = () => {
    return (<>
        <TextContainer>
            <Heading>Example templates:</Heading>
            <List>
                <List.Item>Hi &#123;&#123;name&#125;&#125;, we noticed you didn’t finish your order on WEBSITE. Reply HELP if you would like our assistance or click the link &#123;&#123;recovery_url&#125;&#125; to complete the order. Thanks, BUSINESS NAME.</List.Item>
            </List>
        </TextContainer>
    </>);
}

export default ExampleMessageTemplates;
